import Rockhamptons from './rockhamptonshs_logo.png';
import Stlaurence from './stlaurence.png';
import SCross from './scross.png';
import Beaudesert from './beaudesert.png';
import PGOnline from './pgonline_logo.png';
import PRSPNE from './prspne_logo.png';
import ISFWaterloo from './isfwaterloo.png';
import Albanyshs from './albanyshs.png';
import AviationHigh from './aviationhigh.png';
import Avilacollege from './avilacollege.png';
import Biloelashs from './biloelashs.png';
import BSSSC from './bsssc.png';
import BundabergSHS from './bundabergshs.png';
import GympieSHS from './gympieshs.png';
import MalandaSHS from './malandashs.png';
import Mossmanshs from './mossmanshs.png';
import Namboursc from './namboursc.png';
import NanangoSHS from './nanangoshs.png';
import Pedarecc from './pedarecc.png';
import ProserpineSHS from './proserpineshs.png';
import Redbankplains from './redbankplainsshs.png';
import SpringfieldCentral from './springfieldcentralshs.png';
import StJamesCollege from './stjamescollege.png';
import Spccqld from './spcc.png';
import TannumsandsSHS from './tannumsandsshs.png';
import Tccr from './tccr.png';
import Vpshs from './vpshs.png';
import Wssc from './wssc.png';
import Wmyc from './wmyc.png';
import Woodcrestsc from './woodcrestsc.png';
import Yerongashs from './yerongashs.png';
import Suncoastcc from './suncoastcc.png';
import Chancellorsc from './chancellorsc.png';
import Indoorooshs from './indoorooshs.png';
import Stmaryscollege from './stmaryscollege.png';
import Sampoernaacademy from './sampoernaacademy.webp';
import Aspleyshs from './aspleyshs.png';
import Warwickshswa from './warwickshswa.png';
import Wynnumshs from './wynnumshs.png';
import Trinitybayshs from './trinitybay.png';
import Sisschools from './sisschools.png';
import CharterHouse from './charterhousealmaty.svg';
import Emmaus from './emmaus.png'
import Calliopeshs from './calliopeshs.png';
import Athertonshs from './athertonshs.png';
import Pronin from './pronin.png';
import Transylvania from './transylvania.png';
import VictoryCollege from './victorycollege.png';
import Bmezy from './bmezy.png';
import Peridis from './peridis.png';
import Calvary from './calvary.png';
import Scotspgc from './scotspgc.png';
import Ibid from './ibid.png';
import SevenSteps from './sevensteps.png';

export const Logos = {
  Rockhamptons,
  Stlaurence,
  SCross,
  Beaudesert,
  PGOnline,
  PRSPNE,
  ISFWaterloo,
  Albanyshs,
  AviationHigh,
  Avilacollege,
  Biloelashs,
  BSSSC,
  BundabergSHS,
  GympieSHS,
  MalandaSHS,
  Mossmanshs,
  Namboursc,
  NanangoSHS,
  Pedarecc,
  ProserpineSHS,
  Redbankplains,
  SpringfieldCentral,
  StJamesCollege,
  Spccqld,
  TannumsandsSHS,
  Tccr,
  Vpshs,
  Wssc,
  Wmyc,
  Woodcrestsc,
  Yerongashs,
  Suncoastcc,
  Chancellorsc,
  Indoorooshs,
  Stmaryscollege,
  Sampoernaacademy,
  Aspleyshs,
  Warwickshswa,
  Wynnumshs,
  Trinitybayshs,
  Sisschools,
  CharterHouse,
  Emmaus,
  Calliopeshs,
  Athertonshs,
  Pronin,
  Transylvania,
  VictoryCollege,
  Bmezy,
  Peridis,
  Calvary,
  Scotspgc,
  Ibid,
  SevenSteps
};
